import React from "react";
import { Stack, Typography, Divider } from "@mui/material";

type SectionTitleProps = {
  children: React.ReactNode;
  // Optional right-aligned control on the title's row (e.g. a toggle).
  action?: React.ReactNode;
};

// A section heading: an all-caps, letter-spaced, thin label (the tab-label look) with a thin underline
// always beneath it. Shared so every section title reads the same. An optional right-aligned action
// (e.g. a toggle) sits on the title's row.
const SectionTitle = ({ children, action }: SectionTitleProps) => (
  <>
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{ mt: 2 }}
    >
      <Typography
        component="div"
        sx={{
          textTransform: "uppercase",
          letterSpacing: "0.06em",
          fontWeight: 500,
          fontSize: "0.8125rem",
          color: "text.secondary",
        }}
      >
        {children}
      </Typography>
      {action}
    </Stack>
    <Divider sx={{ mt: 0.25, mb: 1.5 }} />
  </>
);

export default SectionTitle;
